import { render } from "./thankyoumaildiy.vue?vue&type=template&id=47352a58&scoped=true"
import script from "./thankyoumaildiy.vue?vue&type=script&lang=js"
export * from "./thankyoumaildiy.vue?vue&type=script&lang=js"

import "./thankyoumaildiy.vue?vue&type=style&index=0&id=47352a58&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47352a58"]])

export default __exports__